import { NgModule } from '@angular/core';
import { MatCheckboxModule, MatInputModule, MatProgressSpinnerModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseMaterialColorPickerModule } from '@fuse/components/material-color-picker/material-color-picker.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FcTextInputModule } from '../../../../core/components/fc-input/base/fc-text-input/fc-text-input.module';
import { FcListItemModule } from '../../../../core/components/fc-list-item/fc-list-item.module';
import { DialogLinkEquipmentComponent } from './dialog-link-equipment.component';
import { LinkEquipmentDialogService } from './dialog-link-equipment.service';

@NgModule({
  entryComponents: [
    DialogLinkEquipmentComponent
  ],
  declarations: [
    DialogLinkEquipmentComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    FuseMaterialColorPickerModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    MatToolbarModule,
    MatInputModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    FcTextInputModule,
    FcListItemModule
  ],
  providers: [
    LinkEquipmentDialogService
  ],
  exports: [
    DialogLinkEquipmentComponent
  ],
})
export class DialogLinkEquipmentModule {}
